/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Vs_PreviousInputs */

const vi_report_vs_previous = /** @type {(inputs: Report_Vs_PreviousInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`so với kỳ trước`)
};

/**

* @param {Report_Vs_PreviousInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_vs_previous = /** @type {((inputs?: Report_Vs_PreviousInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Vs_PreviousInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_vs_previous(inputs)
});